/**
 *
 * Converts objects property values into an array if they are not already.
 */
const ensureValuesAreArrays = o =>
  Object.keys(o).reduce((acc, key) => {
    const value = o[key];

    if (Array.isArray(value))
      return {
        ...acc,
        [key]: value,
      };

    return {
      ...acc,
      [key]: [value],
    };
  }, {});

export default ensureValuesAreArrays;
